export const user_stores = {
    api: {
        category:                               '/category/{lang}/',
        category_list:                          '/category/{lang}/list',
        category_update:                        '/category/{lang}/{category_id}',
        category_activate:                      '/category/{lang}/activate/{category_id}/{isactive}',

        devices:                                '/devices/{lang}/',
        devices_list:                           '/devices/{lang}/list',
        devices_update:                         '/devices/{lang}/{devices_id}',
        devices_activate:                       '/devices/{lang}/activate/{devices_id}/{isactive}',

        register:                               '/register/{lang}/',
        register_list:                          '/register/{lang}/list',
        register_update:                        '/register/{lang}/{register_id}',
        register_activate:                      '/register/{lang}/activate/{register_id}/{isactive}',
        register_set_data:                      '/register/{lang}/set/{device_id}',
    },

    getters: {
        // ---------------------------------------------------------------------------------------------
        getCategory: (state) => () => {
            return state.api.category.replace('{lang}', state.lang);
        },
        getCategoryList: (state) => () => {
            return state.api.category_list.replace('{lang}', state.lang);
        },
        getCategoryUpdate: (state) => (category_id) => {
            return state.api.category_update.replace('{lang}', state.lang).replace('{category_id}', category_id);
        },
        getCategoryActivate: (state) => (category_id, isactive) => {
            return state.api.category_activate.replace('{lang}', state.lang).replace('{category_id}', category_id).replace('{isactive}', isactive);
        },

        // ---------------------------------------------------------------------------------------------
        getDevices: (state) => () => {
            return state.api.devices.replace('{lang}', state.lang);
        },
        getDevicesList: (state) => () => {
            return state.api.devices_list.replace('{lang}', state.lang);
        },
        getDevicesUpdate: (state) => (devices_id) => {
            return state.api.devices_update.replace('{lang}', state.lang).replace('{devices_id}', devices_id);
        },
        getDevicesActivate: (state) => (devices_id, isactive) => {
            return state.api.devices_activate.replace('{lang}', state.lang).replace('{devices_id}', devices_id).replace('{isactive}', isactive);
        },

        // ---------------------------------------------------------------------------------------------
        getRegister: (state) => () => {
            return state.api.register.replace('{lang}', state.lang);
        },
        getRegisterList: (state) => () => {
            return state.api.register_list.replace('{lang}', state.lang);
        },
        getRegisterUpdate: (state) => (register_id) => {
            return state.api.register_update.replace('{lang}', state.lang).replace('{register_id}', register_id);
        },
        getRegisterActivate: (state) => (register_id, isactive) => {
            return state.api.register_activate.replace('{lang}', state.lang).replace('{register_id}', register_id).replace('{isactive}', isactive);
        },

        getRegisterSetData: (state) => (device_id) => {
            return state.api.register_set_data.replace('{lang}', state.lang).replace('{device_id}', device_id);
        },
    },
    actions: {
        //
    }

};
